<template>
  <v-card outlined>
    <v-card-title> Top Discover </v-card-title>

    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="pagination.items"
        :item-class="(item) => (item.used ? 'item-disabled' : '')"
        disable-filtering
        class="elevation-1"
      >
        <template v-slot:item.action="{ item }">
          <span
            :title="
              item.used
                ? 'Cette source a déjà été utilisée pour générer un article pour ce site'
                : 'Cette source est disponible'
            "
          >
            <v-checkbox
              v-model="page.selected"
              :value="item.adn_post.id"
              :disabled="item.used"
              :key="item.adn_post.id"
              color="primary"
              outlined
              dense
          /></span>
        </template>
        <!-- <template v-slot:item.adn_post.title="{ item }">
          <div class="truncateCell" :title="item.adn_post.title">
            {{ item.adn_post.title }}
          </div>
        </template> -->
        <template v-slot:item.adn_post.url="{ item }">
          <div :title="item.adn_post.url">
            <a :href="item.adn_post.url" target="_blank">Aller voir</a>
            <a :href="item.adn_post.url" target="_blank">
              <v-icon size="14" class="ml-1">
                {{ icons.mdiOpenInNew }}
              </v-icon>
            </a>
          </div>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.truncateCell {
  width: 30rem;
  max-height: 5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  overflow-y: scroll;
}

.originCell {
  width: 15rem;
  height: 2.5rem;
  overflow-x: scroll;
  white-space: nowrap;
  padding-bottom: 0.5rem;
}
</style>
<style>
/* Is not applied when scoped */
tr.item-disabled {
  background-color: lightgrey;
}
</style>

<script>
import { computed, reactive, watch } from "@vue/composition-api";
import { mdiOpenInNew } from "@mdi/js";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";

const HEADERS = [
  {
    text: "Inclus",
    value: "action",
    width: "5rem",
    sortable: false,
  },
  {
    text: "Titre",
    value: "adn_post.title",
    width: "20rem",
    sortable: false,
  },
  {
    text: "Lien",
    value: "adn_post.url",
    width: "10rem",
    sortable: false,
  },
  {
    text: "Date de publication",
    value: "adn_post.created",
    width: "5rem",
    align: "center",
    sortable: false,
  },
];

export default {
  name: "ResultsTable",
  components: {},
  setup(props, { emit }) {
    const { axiosGet } = useAxios();
    const { store } = useProxy();

    const page = reactive({
      loading: false,
      forceCall: false,
      isOptionsInitialized: false,
      selected: [],
    });

    const pagination = reactive({
      numberOfPages: 0,
      total: 0,
      items: [],
      options: {
        page: 1,
        itemsPerPage: 20,
      },
    });

    // =>  METHODS
    const resetState = () => {
      page.selected = [];
    };

    const getPostData = async () => {
      if ((applyFilters.value || page.forceCall) && !page.loading) {
        page.loading = true;

        try {
          const data = await axiosGet("/news-radar-discover/", {
            site_id: site.value,
          });
          // console.log(data);
          pagination.items = data.data;
        } catch (error) {
          console.error("error while fetching data", error);
        }

        page.loading = false;

        // Force clicking on button again to re-run that request :
        // (we don't call this dispatch earlier to be sure, as state is async, that all listening components could run their requests)
        store.dispatch("common/updateApplyFilters", false);
      }

      page.forceCall = false;
    };

    // =>  COMPUTED
    const applyFilters = computed(
      () => store.getters["common/getApplyFilters"]
    );
    const site = computed(() => store.getters["aiFactory/getSelectedSites"]);

    // =>  WATCH
    watch(applyFilters, () => {
      if (applyFilters.value) {
        resetState();
        getPostData();
      }
    });

    watch(
      () => page.selected,
      () => {
        emit("valueChanged", page.selected);
      }
    );

    watch(
      () => pagination.options,
      () => {
        if (page.isOptionsInitialized && !applyFilters.value) {
          // Not on initialization : wait for a real user change
          page.forceCall = true;
          getPostData();
        }

        page.isOptionsInitialized = true;
      }
    );

    // =>  HOOKS

    // =>  DATA
    return {
      icons: {
        mdiOpenInNew,
      },
      page,
      pagination,
      headers: HEADERS,
    };
  },
};
</script>
